import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5457fc2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "create-image" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "电子小票", -1))
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info-top" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "heaeder" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line limit" }, null, -1))
const _hoisted_10 = { class: "key-value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "时间:", -1))
const _hoisted_12 = { class: "info-content" }
const _hoisted_13 = { class: "key-value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单号:", -1))
const _hoisted_15 = { class: "key-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "会员手机:", -1))
const _hoisted_17 = { class: "key-value" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "兑换积分:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_20 = { class: "key-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "商品名:", -1))
const _hoisted_22 = { class: "key-value" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "厂家:", -1))
const _hoisted_24 = { class: "key-value" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "批号:", -1))
const _hoisted_26 = { class: "key-value" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "规格:", -1))
const _hoisted_28 = { class: "key-value" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "有效期:", -1))
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "key-value" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "零售价:", -1))
const _hoisted_33 = { class: "key-value" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "单价:", -1))
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "key-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "数量:", -1))
const _hoisted_38 = { class: "key-value" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "小计:", -1))
const _hoisted_40 = { class: "key-value" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "用药提示:", -1))
const _hoisted_42 = { class: "key-value" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "追溯码:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_45 = {
  key: 0,
  class: "row"
}
const _hoisted_46 = { class: "key-value" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "总价:", -1))
const _hoisted_48 = { class: "key-value" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "优惠:", -1))
const _hoisted_50 = {
  key: 1,
  class: "key-value"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "应付:", -1))
const _hoisted_52 = {
  key: 2,
  class: "row"
}
const _hoisted_53 = { class: "key-value" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "实付:", -1))
const _hoisted_55 = { class: "key-value" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "找零:", -1))
const _hoisted_57 = { class: "key-value" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "付款方式:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_60 = { class: "key-value" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "备注:", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"59px"} }, null, -1))
const _hoisted_63 = { class: "btn-box" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"8px"} }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-box" }, "链接将于24小时内失效，请您尽快保存", -1))

import { computed, onMounted, reactive, ref } from "vue";
import type { UnwrapRef } from "vue";
import dayjs, { Dayjs } from 'dayjs';
import html2canvas from 'html2canvas';
import axios from 'axios';
import { message } from "ant-design-vue"
import MobileFooter from '@/components/mobileFooter.vue'
import {extractUrlQueryParams, isWechatOrEnterpriseWechatBrowser} from '@/utils/index'
import bg_h5_electronic_receipt from '@/images/bg_h5_electronic_receipt.png'
import bg_card_electronic_receipt from '@/images/bg_card_electronic_receipt.png'

interface Obj {
  [key: string]: any
}
interface FormState {
  layout: "horizontal" | "vertical" | "inline";
  name: string;
  phone: string;
  idCard: string;
  area: string;
  birthday: Dayjs;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ElectronicInvoice',
  setup(__props) {

const formState: UnwrapRef<FormState> = reactive({
  layout: "horizontal",
  name: "",
  phone: "",
  idCard: "",
  area: "",
  birthday: dayjs('2000-01-01')
});
const orderInfo = ref<Obj>({})
const browserType = ref(false)
const body = ref<any>(null)
const payType:any = {
          "11": "网银支付",
          "13": "对公打款",
          "14": "银行转账",
          "1": "现金",
          "2": "支付宝",
          "3": "微信支付",
          "4": "医保卡",
          "5": "银行卡",
          "6": "其他",
          "7": "二维码支付",
          "8": "京东支付",
          "9": "云闪付",
          "10": "银联在线支付"
      }
onMounted(() => {
  document.title = '视塔电子小票'
  browserType.value = isWechatOrEnterpriseWechatBrowser()
  const params = extractUrlQueryParams(window.location.href);
  console.log(params); // 输出: { param1: 'value1', param2: 'value2' }
  const postData = new FormData()
  postData.append("ticket", params.t)
  let requestUrl = (params.p != 'SELL_Order.getElectronicReceiptDetail') ? params.p : 'common.handle.getElectronicReceiptDetail'
  axios.post('https://api-erp.yaofangwang.com/' + requestUrl, postData)
    .then((response) => {
      if (response.data?.code == 1) {
        if(params.p == 'common.handle.getStockOutPrintInfo'){
          
          orderInfo.value = {
            Id:response.data.result.orderId,
            shopName:response.data.result.shopName,
            PayTime:response.data.result.createTime,
            OrderNo:response.data.result.orderId,
            OrderDetails:response.data.result.detail.map(res => ({
              NameCN:res.nameCN,
              MillTitle:res.millTitle,
              ProduceNo:res.producedBatch,
              Standard:res.standard,
              PeriodTo:res.batchExpiryDate,
              RealPrice:res.price,
              UnitPrice:res.unitPrice,
              Amount:res.amount,
              MedicationAdvice:res.remark,
              TraceCodeList:res.traceCodeList + '',
            }))
          }

        }
        else {
          orderInfo.value = response.data.result

        }
      }
      else {
        message.error(response.data?.msg)
      }
    })
    .catch((error) => {
      message.error(error.message)
    });
})
const GoodTotalPrice = (item: any): number => {
  return Number(Number(item.RealPrice * item.Amount).toFixed(2))
}
const orderTotalPrice = () => {
  let total = 0
  orderInfo.value.OrderDetails.map((res: any) => {
    total = Number(Number(GoodTotalPrice(res) + total).toFixed(2))
  })
  return total
}


// 使用示例
// const url = "http://example.com/path/to/page?param1=value1&param2=value2";

const submit = async () => {
  
  const target = document.getElementById("create-image")
  if (!target) return;
  if (target.offsetHeight > document.body.offsetHeight) {
    const scale = (document.body.offsetHeight/target.offsetHeight).toFixed(2)
    //要进行缩放
    if(body.value){
      //@ts-ignore
      // body.value.style = `transform:scale(${scale},${scale})`
    }
  }
  html2canvas(target).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    console.log(imgData, 'datatat')
    downloadBase64AsImage(imgData, '视塔软件电子小票')
    //@ts-ignore
    // body.value.style = null
    // 使用imgData创建图片或下载图片
  });
}
function downloadBase64AsImage(base64String: string, fileName: string): void {
  // 分离数据和MIME类型
  const base64Data = base64String.split(',')[1];

  // 将base64解码为ArrayBuffer
  const binaryString = window.atob(base64Data);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // 创建Blob对象
  const blob = new Blob([bytes], { type: 'image/png' }); // 根据实际情况设置MIME类型

  // 创建隐藏的可下载链接
  const linkElement = document.createElement('a');
  linkElement.download = fileName;
  linkElement.href = URL.createObjectURL(blob);
  linkElement.style.display = 'none';

  // 插入DOM并触发点击事件
  document.body.appendChild(linkElement);
  linkElement.click();
  document.body.removeChild(linkElement);

  // 释放URL对象
  URL.revokeObjectURL(linkElement.href);
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (orderInfo.value.Id)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mobile-content",
        ref: (ref) => (body.value = ref)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", { src: _unref(bg_h5_electronic_receipt) }, null, 8, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", { src: _unref(bg_card_electronic_receipt) }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, _toDisplayString(orderInfo.value.shopName  || '-'), 1),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", null, _toDisplayString(orderInfo.value.PayTime  || '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", null, _toDisplayString(orderInfo.value.OrderNo  || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", null, _toDisplayString(orderInfo.value.CustomerMobile || '非会员'), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, _toDisplayString(orderInfo.value.PointsGetQuantity  || '-'), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderInfo.value.OrderDetails, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.Id
                }, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", null, _toDisplayString(item.NameCN || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", null, _toDisplayString(item.MillTitle  || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", null, _toDisplayString(item.ProduceNo  || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", null, _toDisplayString(item.Standard  || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", null, _toDisplayString(item.PeriodTo  || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", null, "￥" + _toDisplayString(item.RealPrice  || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", null, "￥" + _toDisplayString(item.UnitPrice  || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", null, _toDisplayString(item.Amount  || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", null, "￥" + _toDisplayString(GoodTotalPrice(item)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", null, _toDisplayString(item.MedicationAdvice  || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.TraceCodeList && item.TraceCodeList.split(',') || []), (i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(i), 1))
                      }), 128))
                    ])
                  ])
                ], 64))
              }), 128)),
              _hoisted_44,
              (orderInfo.value.ShopOrderTotal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("div", null, "￥" + _toDisplayString(orderInfo.value.ShopOrderTotal  || '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("div", null, "￥" + _toDisplayString(orderInfo.value.ShopDiscountMoney + orderInfo.value.DiscountMoney), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (orderInfo.value.ShopOrderTotal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", null, "￥" + _toDisplayString(orderInfo.value.ShopOrderTotal - (orderInfo.value.ShopDiscountMoney + orderInfo.value.DiscountMoney)), 1)
                  ]))
                : _createCommentVNode("", true),
              (orderInfo.value.ShopOrderTotal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", null, "￥" + _toDisplayString(orderInfo.value.ShopOrderTotal - (orderInfo.value.ShopDiscountMoney + orderInfo.value.DiscountMoney) + orderInfo.value.ReturnMoney + orderInfo.value.PointsDeductionTotal), 1)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createElementVNode("div", null, "￥" + _toDisplayString(orderInfo.value.ReturnMoney  || '-'), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", null, _toDisplayString(payType[orderInfo.value.Payment]  || '-'), 1)
              ]),
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("div", null, _toDisplayString(orderInfo.value.Remarks  || '-'), 1)
              ])
            ])
          ]),
          _hoisted_62,
          _createVNode(MobileFooter)
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存为图片"),
              (browserType.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("（右上角浏览器打开）")
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _hoisted_64,
        _hoisted_65
      ], 512))
    : _createCommentVNode("", true)
}
}

})